export interface ILocationSearch {
  search: string
}

export enum MODE {
  DEFAULT = 'DEFAULT',
  PREVIEW = 'PREVIEW',
}

export const isInPreviewMode = (location: ILocationSearch): boolean => {
  const qs = new URLSearchParams(location.search)
  const mode = qs.get('mode')
  return mode?.toUpperCase() === MODE.PREVIEW
}

type StorefrontEventCaller = () => void

export const skipIfInPreviewMode = (event: StorefrontEventCaller): void => {
  if (isInPreviewMode(window.location)) {
    return
  }

  event()
}
